// Constants
export const examen_pruebas = () => {
    return {
        examen_pruebas: {
            id: {
                description: 'id autoincrement',
                label: 'Id',
                readonly: true,
                type: 'number',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                datatype: {
                    predeterminate: ''
                }
            },
            id_info_examens: {
                type: 'number',
                label: 'Tipo',
                placeholder: '',
                description: 'key forein info_examens',
                readonly: true,
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                datatype: {
                    predeterminate: '',
                }
            },
            ojo_derecho: {
                type: 'text',
                label: 'Ojo derecho',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo derecho',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_izquierdo: {
                type: 'text',
                label: 'Ojo izquierdo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo izquierdo',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ciclopejia: {
                type: 'text',
                label: 'Ciclopejia',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ciclopejia',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            observacion: {
                type: 'text',
                label: 'observacion',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'observacion',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            vision_lejana: {
                type: 'text',
                label: 'Vision Lejana',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Vision Lejana',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            vision_proxima: {
                type: 'text',
                label: 'Vision Proxima',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Vision Proxima',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            obser_1: {
                type: 'text',
                label: 'Observacion',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'observacion de motilidad',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            obser_2: {
                type: 'text',
                label: 'Observacion',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'observacion de punto de convergencia',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_derecho1: {
                type: 'text',
                label: 'Ojo derecho',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo derecho oftalmoscopia',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_izquierdo1: {
                type: 'text',
                label: 'Ojo izquierdo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo izquierdo oftalmoscopia',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_derecho2: {
                type: 'text',
                label: 'Ojo derecho',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo derecho Queratrometria',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_izquierdo2: {
                type: 'text',
                label: 'Ojo izquierdo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo izquierdo Queratrometria',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_derecho3: {
                type: 'text',
                label: 'Ojo derecho',
                name: 'pacOjoder3',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo derecho Refraccion',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_izquierdo3: {
                type: 'text',
                label: 'Ojo izquierdo',
                name: 'pacOjoiz3',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo izquierdo Refraccion',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_derecho4: {
                type: 'text',
                label: 'Ojo derecho',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo derecho RX Final',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_izquierdo4: {
                type: 'text',
                label: 'Ojo izquierdo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo izquierdo RX Final',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_derecho5: {
                type: 'text',
                label: 'Ojo derecho',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo derecho Vision Color',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_izquierdo5: {
                type: 'text',
                label: 'Ojo izquierdo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Ojo izquierdo Vision Color',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            obser_3: {
                type: 'text',
                label: 'Observacion',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Estereopsis',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            codigo: {
                type: 'text',
                label: 'Codigo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'codigo',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            diagnostico: {
                type: 'text',
                label: 'Diagnostico',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Diagnostico',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            ojo_diagnostico: {
                type: 'text',
                label: 'Ojo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'ojo diagnostico',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            origen: {
                type: 'text',
                label: 'Origen',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'origen',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            tipo: {
                type: 'text',
                label: 'Tipo',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Tipo',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            conducta_a: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Conducta A Seguir',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            otras_recomen: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'Otras recomendacion',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_sinco: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_avvl: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_avvp: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_ph: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_rxant: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_avvl2: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_avvp2: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            od_ph2: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_sinco: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_avvl: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_avvp: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_ph: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_rxant: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_avvl2: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_avvp2: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
            oi_ph2: {
                type: 'text',
                label: '',
                dataform: ['paciente_agenda', 'paciente_registrar', 'paciente_historial'],
                placeholder: '',
                description: 'agudeza visual',
                validate: '',
                datatype: {
                    basico: false,
                    type: 'input',
                    disabled: false,
                    predeterminate: '',
                }
            },
        }
    }
}

export function asign_examen_pruebas() {
    var asign = Object.keys(examen_pruebas().examen_pruebas);
    var objeto = examen_pruebas().examen_pruebas
    var nuevoArray = {}
    for (var i = 0; i < asign.length; i++) {
        var createdataform = objeto[asign[i]].dataform
        for (var j = 0; j < createdataform.length; j++) {
            nuevoArray[createdataform[j]] = {}
        }
    }
    return nuevoArray
}